import { Card, CardBody } from "reactstrap"
import SectionHeader from "../../../components/Common/SectionHeader"

export default function AddressCard({
  title = "Addresses",
  icon = "bx bx-map",
  addresses = [],
  action = null,
  noDataText = "No Data",
  placeholder = "N/A",
}) {
  const totalShowrooms = addresses?.length || 0
  const isSingle = totalShowrooms === 1

  // Decide how to format data based on number of addresses
  const formattedData =
    isSingle
      ? [{ label: "Address", value: addresses[0].address || placeholder }]
      : addresses?.map((addr) => [
          { label: "Showroom Name", value: addr.showroom_name || placeholder },
          { label: "Showroom Address", value: addr.showroom_address || placeholder },
          { label: "Address", value: addr.address || placeholder },
          { label: "Email", value: addr.email || placeholder },
          { label: "Mobile", value: addr.mobile || placeholder },
        ]) || []

  return (
    <Card className="border-0 shadow-sm h-100">
      <CardBody className="p-3">
        <SectionHeader
          icon={icon}
          title={isSingle ? title : `${title} (${totalShowrooms})`}
          action={action}
        />
        <div className="specs-list">
          {formattedData.length ? (
            isSingle ? (
              <div className="py-1">
                <span className="text-muted">{formattedData[0].label}:</span>{" "}
                <span className="fw-medium">{formattedData[0].value}</span>
              </div>
            ) : (
              formattedData.map((addrData, index) => (
                <div key={index} className="mb-3 border-bottom pb-2">
                  {addrData.map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex justify-content-between py-1"
                    >
                      <span className="text-muted">{item.label}:</span>
                      <span className="fw-medium">{item.value}</span>
                    </div>
                  ))}
                </div>
              ))
            )
          ) : (
            <small>{noDataText}</small>
          )}
        </div>
      </CardBody>
    </Card>
  )
}
